import React, { useEffect } from "react";
import ComponentRequest from "./ComponentRequest";
import { useSelector } from "react-redux";
import { curStateAccount } from "../../../../Redux/selector";
import Cookies from "universal-cookie";
import MiniGamePageHome from '../Home';
import { useLoginModal } from '@/contexts/LoginModalContext';

export default function RequestPiece() {
  const cookies = new Cookies();
  const selectorAccount = useSelector(curStateAccount);
  const isLogin = cookies.get("isLoggedIn");
  const { openLogin } = useLoginModal();

  const isAuthed = Boolean(selectorAccount?.userInfo) || Boolean(isLogin);

  useEffect(() => {
    if (!isAuthed) {
      openLogin();
    }
  }, [isAuthed]);

  return (
    <>
      {isAuthed ? <ComponentRequest /> : <MiniGamePageHome />}
    </>
  );
}